import React, { useRef, useState, useEffect } from 'react';
import Header from '../../Header/Header';
import SectionWrapper from '../../common/SectionWrapper/SectionWrapper';
import TicketSelector from '../../TicketSelector/TicketSelector';
import CharityBlock from '../../common/CharityBlock/CharityBlock';
import TimelineBlock from '../../common/TimelineBlock/TimelineBlock';
import Footer from '../Footer/Footer';
import Hero from '../Hero/Hero';
import MobileCTAButtonBottom from '../../mobile-cta-button-bottom';
import PageLoader from '../../../components/PageLoader/PageLoader';
import useIsLoggedIn from '../../../hooks/useIsLoggedIn';
import { getUser } from '../../../services/users';
import './styles.css';

const Main = (props) => {
  const {
    prize,
    prizeId,
    raffles,
    raffle,
    isExpired,
    activeRaffles,
    subscriptionModels,
    data,
    onCTAClick,
    onLearnMoreClick,
    onLearnMoreCharityClick,
    onTwo4One,
    widgets,
    content,
    bonusDraw,
    flashDraw,
  } = props;
  const ticketSelectorRef = useRef(null);
  const [isDouble, setIsDouble] = useState(false);
  const isLoggedIn = useIsLoggedIn();
  const [user, setUser] = useState(null);

  useEffect(() => {
    if (!isLoggedIn) {
      setUser(null);
      return;
    }

    let cancelled = false;

    getUser().then((fetchedUser) => {
      if (!cancelled) {
        setUser(fetchedUser);
      }
    });

    return () => {
      cancelled = true;
    };
  }, [isLoggedIn]);

  useEffect(() => {
    if (props.raffles && props.raffles.length > 1) {
      setIsDouble(true);
    }
  }, [props.raffles]);

  if (!content || !content.dreamHome) {
    return (
      <div className="app">
        <Header raffle={raffle} user={user} />
        <PageLoader loading />
        <Footer insideComponent={true} widget={widgets.footerWidget} />
      </div>
    );
  }

  return (
    <>
      {prizeId ? (
        <div className="app">
          <Header raffle={raffle} user={user} />
          <main>
            <Hero
              onCTAClick={onCTAClick}
              onTwo4One={onTwo4One}
              content={content}
              raffles={raffles}
              flashDraw={flashDraw}
            />
            <MobileCTAButtonBottom
              variant="variant-2"
              currentRaffle={raffle}
              withCountdown
              raffles={activeRaffles.length > 0 ? activeRaffles : raffles}
            />
            <SectionWrapper bg="bg-2">
              <TicketSelector
                reference={ticketSelectorRef}
                title={data.ticketSelector.title}
                subtitle={content.dreamHome.timeLine.description}
                prizeId={prizeId}
                subscriptionModels={subscriptionModels}
                raffles={activeRaffles.length > 0 ? activeRaffles : raffles}
                currentRaffle={raffle}
                theme="light"
                bonusDraw={bonusDraw}
                user={user}
              />
            </SectionWrapper>
            <SectionWrapper bg="bg-1">
              <CharityBlock
                onCTAClick={onCTAClick}
                onLearnMoreClick={onLearnMoreClick}
                onLearnMoreCharityClick={onLearnMoreCharityClick}
              />
            </SectionWrapper>
            <SectionWrapper bg="bg-2">
              <TimelineBlock
                onCTAClick={onCTAClick}
                content={content.dreamHome.timeLine}
              />
            </SectionWrapper>
            <SectionWrapper bg="bg-1">
              <div className="footer-margin"></div>
            </SectionWrapper>
            <Footer
              insideComponent={true}
              widget={widgets.footerWidget}
              bonusDraw={bonusDraw}
            />
          </main>
        </div>
      ) : (
        <main className="no-prize">
          <h1>No prize</h1>
        </main>
      )}
    </>
  );
};

export default Main;
